/* eslint-disable react/display-name */
import { Button, Input, Space, Typography } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import styles from 'src/styles/layout.module.css';
import {
  addFirmwareToGroup,
  fetchGroupFirmwares,
  removeFirmwareFromGroup,
} from 'src/features/deviceGroups/deviceGroups.state';
import { AppDispatch } from 'src/index';
import { useDispatch } from 'react-redux';
import { useDeviceGroupFirmwaresById } from 'src/features/deviceGroups/deviceGroups.hooks';
import { FormattedMessage, useIntl } from 'react-intl';
import { SearchOutlined } from '@ant-design/icons';
import { Firmware } from 'src/features/firmwares/firmwares.types';
import FirmwaresTable from 'src/components/pages/DeviceGroupPage/DeviceGroupFirmwaresTab/FirmwaresTable';
import { fetchFirmwares } from 'src/features/firmwares/firmwares.state';

const DeviceGroupFirmwaresTab: React.FC = () => {
  const { groupId } = useParams() as { groupId: string };
  const dispatch: AppDispatch = useDispatch();
  const intl = useIntl();
  const firmwares = useDeviceGroupFirmwaresById(groupId);
  const [addMode, setAddMode] = useState(false);
  const [search, setSearch] = useState<string | undefined>(undefined);

  const [newGroupFirmwares, setNewGroupFirmwares] = useState<Firmware[]>([]);

  useEffect(() => {
    dispatch(fetchGroupFirmwares({ groupId }));
  }, [dispatch, groupId]);

  const getFirmwaresNotInGroup = async () => {
    const res = await dispatch(fetchFirmwares({}));
    if (fetchFirmwares.fulfilled.match(res)) {
      const ids = firmwares.map(f => f.id);
      console.log(res.payload.filter(r => !ids.includes(r.id)));
      setNewGroupFirmwares(res.payload.filter(r => !ids.includes(r.id)));
    }
  };

  const onAddFirmware = useCallback(
    async (firmware: Firmware) => {
      const res = await dispatch(addFirmwareToGroup({ groupId, data: { firmwareId: firmware.id } }));
      if (addFirmwareToGroup.fulfilled.match(res)) {
        setNewGroupFirmwares(newGroupFirmwares.filter(f => f.id !== firmware.id));
        dispatch(fetchGroupFirmwares({ groupId }));
      }
    },
    [dispatch, groupId, newGroupFirmwares]
  );

  const onRemove = useCallback(
    async (firmware: Firmware) => {
      await dispatch(removeFirmwareFromGroup({ groupId, firmwareId: firmware.id }));
    },
    [dispatch, groupId]
  );

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <Space style={{ width: '100%', marginBottom: 10, justifyContent: 'space-between' }}>
          <Typography.Title level={4} style={{ marginBottom: 0 }}>
            Шлемы
          </Typography.Title>
          {addMode ? (
            <Button
              onClick={() => {
                setAddMode(false);
              }}
            >
              <FormattedMessage id={'action.close'} />
            </Button>
          ) : (
            <Button
              type={'primary'}
              onClick={async () => {
                setAddMode(true);
                await getFirmwaresNotInGroup();
              }}
            >
              <FormattedMessage id={'action.add'} />
            </Button>
          )}
        </Space>
      </div>
      <div className={styles.content}>
        <Input
          autoFocus
          allowClear
          placeholder={intl.formatMessage({ id: 'placeholder.search' })}
          prefix={<SearchOutlined />}
          onChange={e => {
            setSearch(e.target.value);
          }}
          style={{ marginBottom: 10 }}
          value={search}
        />
        <FirmwaresTable
          firmwares={addMode ? newGroupFirmwares : firmwares}
          onAdd={onAddFirmware}
          onRemove={onRemove}
          addMode={addMode}
        />
      </div>
    </div>
  );
};

export default DeviceGroupFirmwaresTab;
